import axios from 'axios';

const utils = {};
const rootPath = process.env.NODE_ENV === 'production' ? 'http://35.189.238.119' : `http://${location.hostname}:3000`;
const headers = {
  'x-goog-project-id': 144043847891,
};
/**
 * Fetch a product from Decathlon's API
 * @param  {String}    ref       One reference like '123456'
 * @param  {Function}  callback
 */
utils.fetchProduct = (ref, callback) => {
  const inputJSON = { productId: `${ref}`, productLocale: 'it_IT' };
  const serverURL = process.env.NODE_ENV === 'production' ?
    `${rootPath}/?serviceName=WSGetProductInfo&inputJSON={"productId":"${ref}","productLocale":"it_IT"}` :
    `${rootPath}/?serviceName=WSGetProductInfo&inputJSON=${encodeURIComponent(JSON.stringify(inputJSON))}`;
  axios({
    method: 'get',
    url: serverURL,
    headers,
  })
  .then((response) => {
    const datas = response.data.outputJSON[0].productInfo;
    callback(datas);
  })
  .catch((e) => {
    callback(null);
    console.log(e);
  });
};

/**
 * Fetch an array of products from Decathlon's API
 * @param  {Array}    refs     Array of references like ['123456', '987654']
 * @param  {Function} callback
 */
utils.fetchAllProducts = (refs, callback) => {
  let found = 0;
  const array = [];
  const productsReturn = (datas) => {
    window.vm.$Progress.start();
    found += 1;
    if (datas != null && (datas.productVariant).length && (datas.openGraph.image).slice(-1) !== '_') { array.push(datas); }
    if (found === refs.length) {
      callback(array);
      window.vm.$Progress.finish();
    }
  };
  refs.forEach(ref => utils.fetchProduct(ref, productsReturn));
};

utils.getBorderedViewport = () => {
  let height = 0;
  const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  const borderTop = document.getElementsByClassName('mxr-l-borders--top');
  const borderBottom = document.getElementsByClassName('mxr-l-borders--bottom');
  const navigationBottom = document.getElementsByClassName('mxr-c-nav');

  height = borderTop[0].offsetHeight
    + borderBottom[0].offsetHeight
    + navigationBottom[0].offsetHeight;
  height = viewportHeight - height;
  return height;
};

utils.outerHeight = (el) => {
  let height = el.offsetHeight;
  const style = getComputedStyle(el);
  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  return height;
};

utils.isTouchDevice = () => 'ontouchstart' in document.documentElement;

export default utils;



// WEBPACK FOOTER //
// ./src/utils.js